// extracted by mini-css-extract-plugin
module.exports = {"outdoor-recreation-D":"Other_outdoor-recreation-D__aMnWA"};